import { css } from 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import space from '../styled/space.js';
import '../styled/index.js';
var Tag = {
  base: css(["border-radius:30px;text-transform:uppercase;"]),
  TagContent: {
    base: css(["padding:0 ", "em;"], space(3))
  }
};
export default Tag;